import { render, staticRenderFns } from "./KillfeedItemDefuse.vue?vue&type=template&id=17bbfc46&scoped=true&"
import script from "./KillfeedItemDefuse.vue?vue&type=script&lang=js&"
export * from "./KillfeedItemDefuse.vue?vue&type=script&lang=js&"
import style0 from "./KillfeedItemDefuse.vue?vue&type=style&index=0&id=17bbfc46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bbfc46",
  null
  
)

export default component.exports